export const convertToTitleCase = (name: string = ""): string =>
  name.toLowerCase().replace(/(\b[a-z])/g, (char) => char.toUpperCase());
